var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_272)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3384 25.0822C15.0053 26.5289 13.4528 27.8245 11.7095 28.8724C11.4949 29.0281 11.2039 29.047 10.9654 28.896C8.38982 27.2746 6.22678 25.3276 4.5264 23.2107C2.17974 20.2984 0.703532 17.0699 0.197949 13.9594C-0.317173 10.8064 0.164562 7.77139 1.75047 5.30516C2.37529 4.33047 3.17421 3.4431 4.14722 2.67609C6.38418 0.913154 8.93833 -0.0190568 11.4853 -0.000176551C13.9369 0.0187037 16.3575 0.922594 18.449 2.81297C19.1835 3.47378 19.8012 4.23135 20.3068 5.05264C22.0119 7.83275 22.3792 11.3775 21.6304 14.9695C20.8911 18.5189 19.0548 22.1251 16.3384 25.0751V25.0822ZM10.9988 5.60725C14.0228 5.60725 16.472 8.03335 16.472 11.0235C16.472 14.016 14.0204 16.4398 10.9988 16.4398C7.97486 16.4398 5.52565 14.016 5.52565 11.0235C5.52326 8.03099 7.97486 5.60725 10.9988 5.60725Z",
    fill: "#11998E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.f739bd0bbbc4c55dc76f1d44f480cf13.svg";
export { ForwardRef as ReactComponent };